import { ReactComponent as InnovationArrow } from "./innovation-arrow.svg";

const PopularityTrendGapInnovationScale = () => (
    <>
        <div className="PopularityTrendGapChart__innovation-group">
            <span className="PopularityTrendGapChart__innovation-risk">lower risk</span>
            <span className="PopularityTrendGapChart__innovation-arrow">
                <InnovationArrow
                    className="PopularityTrendGapChart__innovation-arrow-icon PopularityTrendGapChart__innovation-arrow-icon--up"
                    aria-hidden="true"
                    focusable="false"
                />
            </span>
        </div>

        <span className="PopularityTrendGapChart__innovation-label">Innovation Opportunity</span>

        <div className="PopularityTrendGapChart__innovation-group">
            <span className="PopularityTrendGapChart__innovation-arrow">
                <InnovationArrow
                    className="PopularityTrendGapChart__innovation-arrow-icon PopularityTrendGapChart__innovation-arrow-icon--down"
                    aria-hidden="true"
                    focusable="false"
                />
            </span>
            <span className="PopularityTrendGapChart__innovation-risk">higher risk</span>
        </div>
    </>
);

export default PopularityTrendGapInnovationScale;
